import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { AdminFeedbacksRoutes } from '@repo/shared/api-routes/admin/feedbacks'
import { FeedbackDTO } from '@repo/shared/dtos/feedback'
import { AxiosInstance } from 'axios'

import { toChatMessage } from '@/external/api/chunks/api-chat-sessions'
import { IFeedbacksApi } from '@/spi/api/feedbacks'
import { Feedback } from '@/store/admin'

export const buildFeedbacksApi = (axios: AxiosInstance): IFeedbacksApi => ({
  getAll: async ({ organizationId }) => {
    const response = await tryCatch(async () =>
      axios.get<typeof AdminFeedbacksRoutes.getAll.response>(
        AdminFeedbacksRoutes.getAll.getPath({ organizationId }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return toFeedbacks(response.data)
  },
})

function toFeedbacks(feedbacks: FeedbackDTO[]): Feedback[] {
  return feedbacks.map((f) => ({
    id: f.id,
    content: f.content,
    createdAt: f.createdAt,
    chatSessionId: f.chatSessionId,
    beneficiaryId: f.beneficiaryId,
    message: toChatMessage(f.message),
  }))
}
